import { apiClient } from '@/shared/lib/apiClient';
import type { ApiResponse, Booking, PaginatedResponse } from '@/types';

export const adminDisputesApi = {
  async list(params?: { page?: number; limit?: number }) {
    const res = await apiClient.get<PaginatedResponse<Booking>>('/admin/disputes', { params });
    return { data: res.data.data, pagination: res.data.pagination };
  },

  async resolve(id: string, payload: { resolution: 'guide_favor' | 'traveler_favor'; adminNotes?: string }) {
    const res = await apiClient.patch<ApiResponse<Booking>>(`/admin/disputes/${id}/resolve`, payload);
    return res.data.data!;
  },
};

export const adminDisputesKeys = {
  all: ['admin-disputes'] as const,
  list: (params?: Record<string, unknown>) => [...adminDisputesKeys.all, 'list', params] as const,
};
